<template>
  <div>
    <el-steps :active="activeStep" align-center finish-status="success" simple>
      <el-step v-for="item in stepList" :key="item.title" :icon="item.icon" :title="item.title" />
    </el-steps>
    <el-form class="register-form" ref="registerForm" :rules="rules" :model="form" label-width="95px">
      <template v-if="activeStep === 0">
        <el-form-item label="角色" prop="roleId">
          <el-select v-model.number="form.roleId" placeholder="请选择身份" @change="getDepts">
            <el-option
                v-for="role in roleList"
                :key="role.roleId"
                :label="role.approval !== 1 ? role.roleName : `${role.roleName}（需审核）`"
                :value="role.roleId"
            />
            <i slot="prefix" class="icon el-icon-user-solid" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="curRole && curRole.approval === 1" label="学校" prop="deptId">
          <el-select clearable filterable allow-create default-first-option v-model.number="form.deptId" placeholder="请选择/填写学校（全称）">
            <el-option v-for="dept in deptList" :key="dept.deptId" :label="dept.name" :value="dept.deptId" />
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input clearable v-model="form.name" placeholder="真实姓名">
            <i slot="prefix" class="icon el-icon-user-solid" />
          </el-input>
        </el-form-item>
        <el-form-item label="注册邀请码" prop="joinCode" v-if="curRole && curRole.approval !== 1">
          <el-input clearable v-model="form.joinCode" placeholder="请输入邀请码（10位字母与数字组成）">
            <i slot="prefix" class="icon el-icon-c-scale-to-original" />
          </el-input>
        </el-form-item>
        <el-form-item v-else label="可邀请用户数" prop="inviteUserCountMax">
          <el-input-number v-model.number="form.inviteUserCountMax" :min="0" :max="100" :step="10" placeholder="请输入最大邀请用户数" />
        </el-form-item>
      </template>
      <template v-else-if="activeStep === 1">
        <el-form-item label="手机号" prop="mobile">
          <el-input clearable v-model="form.mobile" placeholder="11位国内手机号">
            <i slot="prefix" class="icon el-icon-phone" />
          </el-input>
        </el-form-item>
        <el-form-item label="手机验证码" prop="phoneCode">
          <el-input clearable placeholder="请输入手机验证码" v-model="form.phoneCode">
            <el-button slot="append" size="small" :disabled="disSendBtn" @click="sendPhoneCode">{{disSendBtn?`${undisSendBtnTime}秒后重试`:"发送验证码"}}</el-button>
          </el-input>
        </el-form-item>
      </template>
      <template v-else-if="activeStep === 2">
        <el-form-item label="密码" prop="password">
          <el-input clearable type="password" v-model="form.password" placeholder="请设置登录密码">
            <i slot="prefix" class="icon icon-password" />
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="password2">
          <el-input clearable type="password" v-model="form.password2" placeholder="请输入确认密码" @keyup.enter.native="register">
            <i slot="prefix" class="icon icon-password" />
          </el-input>
        </el-form-item>
      </template>
      <template v-else>
        <div class="text-center register-finish">
          手机用户{{form.mobile}}你好，<br/>欢迎使用实验工坊！<br/>
          <template v-if="approvalB">
            我们将在下个工作日的17：30前对您的账号审批完毕！<br/>
            审批通过后，你可去<router-link to="/">首页</router-link>登录！<br/>
          </template>
          <template v-else>
            注册成功！现在去<router-link to="/">首页</router-link>登录！<br/>
          </template>
        </div>
      </template>

      <div class="text-right">
        <el-button v-if="activeStep > 0 && activeStep < stepList.length-1" type="primary" size="small" plain @click="prevStep">上一步</el-button>
        <el-button v-if="activeStep+1 === stepList.length-1"
                   type="primary"
                   size="small"
                   :loading="loading"
                   @click="register"
                   :disabled="!checked"
        >注&nbsp;&nbsp;册</el-button>
        <el-button v-else-if="activeStep < stepList.length-1" type="primary" size="small" @click="nextStep">下一步</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import TreeUtil from "@/utils/treeUtil";
import { tenantCode } from '@/config/env'
import { sendSmsByPhone, registerByPhone, duplicateCheck } from "@/api/system/user";
import { getRoleList } from "@/api/system/role";
import { getDeptListTree } from "@/api/system/dept";

const defData = {
  //   roleId: 3,
  mobile: '',
  // 所属租户
  tenantCode,
  inviteUserCountMax: 0,
  phoneCode: '',
    name: '',
    nickname: ''
};
export default {
  name: "RegisterForm",
  data() {
    // 验证手机号
    let checkPhone = (rule, mobile, callback) => {
      if (!mobile || mobile === "") {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3456789]\d{9}$/.test(mobile)) {
        callback(new Error("手机号码有误，请重填"));
      } else {
        // 远程验证手机号是否存在
        duplicateCheck({
          mobile
        }).then(res => {
          if (res) callback(new Error("手机号已存在，请重新输入"));
          callback();
        });
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (!value || value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      // 当前步骤索引
      activeStep: 0,
      // 步骤列表
      stepList: [
        { title: "基本信息", icon: "el-icon-info" },
        { title: "绑定手机", icon: "el-icon-mobile-phone" },
        { title: "设置密码", icon: "el-icon-key" },
        { title: "完成", icon: "el-icon-finished" }
      ],
      disSendBtn: false,
      undisSendBtnTime: 60,
      sendBtnTimer: null,
      // 表单数据
      form: defData,
      // 表单验证
      rules: {
        mobile: [{ required: true, validator: checkPhone, trigger: "change" }],
        phoneCode: [
            { required: true, message: "请输入手机验证码", trigger: "blur" },
            { min: 6, max: 6, message: "请输入6位验证码", trigger: "blur" }
        ],
        roleId: [
          { required: true, message: "请选择角色", trigger: "blur" }
        ],
        deptId: [
          { required: true, message: "请选择/填写组织机构", trigger: "blur" }
        ],
          name: [
              { required: true, message: "请填写真实姓名", trigger: "blur" }
          ],
        inviteUserCountMax: [
          { required: true, type: "number", min: 0, max: 100, message: "请设置可邀请用户数", trigger: "blur" }
        ],
        joinCode: [
          { required: true, message: "请输入邀请码", trigger: "blur" },
          {
            min: 10,
            max: 10,
            message: "请输入10位由数字、字母组成的字符串",
            trigger: "blur"
          }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password2: [{ required: true, validator: validatePass2, trigger: "blur" }],
      },
      checked: true,
      loading: false,
      validCode: "",
      // 机构列表（全部）
      allDept: [],
      // 自主注册用户可选机构
      deptList: [],
      // 自主注册用户可选角色
      roleList: []
    };
  },
  computed: {
    curRole() {
      const { roleId } = this.form;
      let curRole = this.roleList.filter(role => role.roleId === roleId);
      if (curRole.length > 0) return {
        defaultDeptId: undefined,
        roleName: undefined,
        ...curRole[0]
      };

      return null;
    },
    // 是否需要审核
    approvalB() {
        if (this.curRole === null) {
            return true
        }
        const { approval } = this.curRole;
        return approval === 1;
    }
  },
  created() {
    this.getRoles();
    this.getDepts();
  },
  watch: {
    "form.roleId"(val) {
      delete this.form.deptId;
      if (val > 0) {
          this.$refs["registerForm"].clearValidate()
          this.getDepts();
      }
    }
  },
  methods: {
    async getRoles() {
      // 判断是否注册弹窗与角色列表是否获取
      await getRoleList({
        isShow: 1
      }).then(res => {
        this.roleList = res;
        this.$set(this.form, "roleId", this.roleList[0].roleId);
      });
    },
    async getDepts() {
      // 判断机构列表是否获取
      if (this.allDept.length < 1) {
        await getDeptListTree().then(res => {
          res = Object.assign({}, res)
          this.allDept = res.deptList || [];
        });
      }

      let curRole = this.curRole;
      if (curRole == null) return;

      // 根据角色，筛选出可选机构列表
      let deptId = curRole.defaultDeptId || 0; // 默认注册的机构ID，所有注册用户都注册在此机构下

      // 根据机构ID找出其子机构
      try {
        this.deptList = new TreeUtil(this.allDept, "deptId").toChildren(
          deptId
        )[0].children;
      } catch (error) {
        this.deptList = [];
      }
    },
    handleIntervalSendBtn() {
        // 禁用发送验证码按钮
        this.disSendBtn = true
        this.undisSendBtnTime = 60
        clearInterval(this.sendBtnTimer)
        this.sendBtnTimer = setInterval(() => {
            if (this.undisSendBtnTime === 1) {
                clearInterval(this.sendBtnTimer)
                this.disSendBtn = false
                return
            }
            this.undisSendBtnTime--
        }, 1000)
    },
    // 发送手机验证码
    sendPhoneCode() {
        this.$refs["registerForm"].validateField("mobile", errMsg => {
            if (errMsg) {
                return
            }
            let { mobile: phone } = this.form
            sendSmsByPhone(phone)
            this.handleIntervalSendBtn()
        })
    },
    // 上一步
    prevStep() {
        if (this.activeStep > 0) {
            this.activeStep--
        }
    },
    // 下一步
    nextStep() {
      this.$refs["registerForm"].validate(boolean => {
        if (!boolean) {
          return
        }
        if (this.activeStep === this.stepList.length-1) {
          this.activeStep = 0
          return
        }
        this.activeStep++
      })
    },
    // 用户注册
    register() {
      this.loading = true;
      // 表单验证
      this.$refs["registerForm"].validate(boolean => {
        // 表单验证通过
        if (boolean) {
          const { roleId, deptId, name } = this.form;
          const { approval } = this.curRole;
          // 是否需要审核
          const approvalB = approval === 1;
          let row = Object.assign(
            {
              // 角色
              roleIdList: [roleId]
            },
            this.form,
              {
                  nickname: name
              }
          );
          delete row.roleId;
          delete row.password2;

          if (approvalB) {
            delete row.joinCode;
            if (isNaN(Number(deptId))) {
              // 自定义组织机构
              row.deptName = deptId;
              delete row.deptId;
            }
          } else {
            delete row.inviteUserCountMax;
            delete row.deptId
          }
          registerByPhone(row).then(() => {
            this.activeStep++
          })
        }
      });
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.register-form {
  margin-top: 1em;
  .el-select,
  .el-cascader,
  .el-input-number{
    width: 100%;
  }
}
</style>

<style lang="scss" scoped>
  .register-form {
    .register-finish {
      line-height: 1.6em;
      padding: 2em 0;
    }
  }
</style>
